<template>
  <div class="ratings">
    <div class="rating" :key="rating.id" v-for="rating in ratings">
      <div class="stars"></div>
      <blockquote class="text"> {{rating.text}} </blockquote>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ratings',
  props: {
    ratings: Array,
  },
};
</script>

<style lang="scss" scoped>
  .ratings {
    margin-top: var(--bg-spacer);
    @media (min-width: 50em) {
      margin: 0;
    }
  }

  .rating {
    padding: calc(var(--sm-spacer) / 1.5) calc(var(--sm-spacer) / 2);
    font-weight: bold;
    border-radius: var(--border-radius);
    font-size: 1rem;

    background-color: var(--light-grayish-magenta);
    color: var(--very-dark-magenta);

    + .rating {
      margin-top: var(--sm-spacer);
    }

    @media (min-width: 50em) {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: calc(var(--border-radius) + 0.5rem);
      max-width: 27rem;
      margin: 0 auto;

      &:nth-child(2) {
        transform: translateX(3.5rem);
      }

      &:nth-child(3) {
        transform: translateX(7rem);
      }
    }

    .stars {
      width: 100px;
      margin: 0 auto;
      height: var(--sm-spacer);
      background: url(../../assets/sps/icon-star.svg);
      background-repeat: space;

      @media (min-width: 50em) {
        margin: 0;
      }
    }
  }
</style>
